/**
 * Workflow-related constants and configuration
 */
import { Circle, Play, CheckCircle, SkipForward } from 'lucide-react';

export const statuses = [
  { value: 'pending', label: 'Pending', color: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200' },
  { value: 'in_progress', label: 'In Progress', color: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200' },
  { value: 'completed', label: 'Completed', color: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200' },
  { value: 'on_hold', label: 'On Hold', color: 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200' },
  { value: 'cancelled', label: 'Cancelled', color: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200' },
];

export const milestoneStatuses = [
  { value: 'pending', label: 'Pending', icon: Circle, color: 'text-gray-400', bg: 'bg-gray-200' },
  { value: 'in_progress', label: 'In Progress', icon: Play, color: 'text-blue-500', bg: 'bg-blue-500' },
  { value: 'completed', label: 'Completed', icon: CheckCircle, color: 'text-green-500', bg: 'bg-green-500' },
  { value: 'skipped', label: 'Skipped', icon: SkipForward, color: 'text-orange-500', bg: 'bg-orange-500' },
];

export const workflowTypes = [
  { value: 'school_photo', label: 'School Photo' },
  { value: 'sports_event', label: 'Sports Event' },
  { value: 'portrait_session', label: 'Portrait Session' },
  { value: 'other', label: 'Other' },
];

export const workflowCategories = [
  { value: 'marketing', label: 'Marketing', color: 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200' },
  { value: 'prephotoday', label: 'Schedule', color: 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200' },
  { value: 'production', label: 'Production', color: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200' },
  { value: 'feedback', label: 'Feedback', color: 'bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-200' },
];

// Label mapping for categories
export const categoryLabels = {
  marketing: 'Marketing',
  prephotoday: 'Schedule',
  production: 'Production',
  feedback: 'Feedback'
};

// Status config with variants
export const statusConfig = {
  pending: { label: 'Pending', variant: 'secondary' },
  in_progress: { label: 'In Progress', variant: 'default' },
  completed: { label: 'Completed', variant: 'success' },
  on_hold: { label: 'On Hold', variant: 'outline' },
  cancelled: { label: 'Cancelled', variant: 'destructive' }
};

export const overdueDaysOptions = [
  { value: 'all', label: 'All Workflows' },
  { value: '1', label: 'Overdue 1+ days' },
  { value: '3', label: 'Overdue 3+ days' },
  { value: '7', label: 'Overdue 7+ days' },
  { value: '14', label: 'Overdue 14+ days' },
  { value: '30', label: 'Overdue 30+ days' },
];
